import Vue from 'vue';
import { GetterTree } from 'vuex';
import { RootState, ProfileState } from '../../types';
import { validationMixin, Validation } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { ProfileSuccess, ProfileValidationErrors } from './types';

const getters: GetterTree<ProfileState, RootState> = {
  validator(state: ProfileState): Validation {
    return new Vue({
      mixins: [validationMixin],
      computed: {
        name: () => state.user.name,
        email: () => state.user.email,
        phone: () => state.user.phone,
      },
      validations: {
        name: { required },
        email: { required, email },
        phone: { required },
      },
    });
  },

  errors(state: ProfileState, getters): ProfileValidationErrors {
    const formErrors: ProfileValidationErrors = {
      name: [],
      email: [],
      phone: [],
    };

    /** Name */
    !getters.validator.$v.name.required &&
      formErrors.name.push('Name is required.');

    /** Email */
    !getters.validator.$v.email.required &&
      formErrors.email.push('Email is required.');

    !getters.validator.$v.email.email &&
      formErrors.email.push('Enter with a valid email format.');

    /** Phone */
    !getters.validator.$v.phone.required &&
      formErrors.phone.push('Phone is required.');

    return formErrors;
  },

  success(
    state: ProfileState,
    getters,
    rootState,
    rootGetters
  ): ProfileSuccess {
    const formSuccess: ProfileSuccess = {
      name: '',
      email: '',
      phone: '',
    };

    const user = rootGetters['auth/getUserData'];

    state.user.name != user.name &&
      !getters.validator.$v.name.$invalid &&
      (formSuccess.name = 'Name is valid.');

    state.user.email != user.email &&
      !getters.validator.$v.email.$invalid &&
      (formSuccess.email = 'Email is valid.');

    state.user.phone != user.phone &&
      !getters.validator.$v.phone.$invalid &&
      (formSuccess.phone = 'Phone is valid.');

    return formSuccess;
  },

  valid(state: ProfileState, getters, rootState, rootGetters) {
    const user = rootGetters['auth/getUserData'];
    return (
      !getters.validator.$v.$invalid &&
      (state.user.name != user.name ||
        state.user.email != user.email ||
        state.user.phone != user.phone)
    );
  },
};

export default getters;
